import DomainEntity from '@/models/DomainEntity'

export default class StateAvailableContracts extends DomainEntity {
  static get collectionName() {
    return 'stateavailablecontracts/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: [],
    }
  }
}
